import { jwtDecode } from "jwt-decode";
import { User } from "@/types";

const ADMIN_TOKEN_KEY = "admin_key"

export const storeAdminAuthToken = (token: string) => {
    const user = parseJWTToken(token);
    if (user) {
        localStorage.setItem(ADMIN_TOKEN_KEY, token);
    } else {
        //clear ?
        localStorage.removeItem(ADMIN_TOKEN_KEY);
    }
    return user;

}

export const getStoredAdminAuthToken = () => {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    return {
        token,
        user: token ? parseJWTToken(token) : undefined
    }
}

const isAdminPath = (path: string) => {
    return path === "/admin" || path.startsWith("/admin/");
};

/**
 * Set admin user only when the current route is an admin route.
 */
export const getInitialAdminUser = (): User | undefined => {
    if (typeof window === "undefined") return undefined;
    const { pathname } = window.location;
    if (!isAdminPath(pathname)) return undefined;

    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    return token ? parseJWTToken(token) : undefined;
};

export const clearAdminAuthToken = () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export const parseJWTToken = (token: string): User | undefined => {
    try {
        const jwt = jwtDecode(token) as any;
        if (jwt.exp && jwt.exp * 1000 > Date.now()) {
            return {
                appId: jwt.aud as string,
                userId: jwt.id as string,
                email: jwt.email,
                provider: jwt.idp,
                avatarURL: jwt.pic,
                firstName: jwt.firstName,
                lastName: jwt.lastName,
                role: jwt.role
            };
        }
    } catch (e) {
        console.error("Could not parse JWT token " + token + ", Error: ", e);
    }
}
